import { render } from "./platform.vue?vue&type=template&id=21b6124c&scoped=true"
import script from "./platform.vue?vue&type=script&lang=js"
export * from "./platform.vue?vue&type=script&lang=js"

import "./platform.vue?vue&type=style&index=0&id=21b6124c&rel=stylesheet%2Fscss&lang=scss&scoped=true"

import exportComponent from "/home/pages/train-pc/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21b6124c"],['__file',"src/views/my/platform.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "21b6124c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('21b6124c', __exports__)) {
    console.log('reload')
    api.reload('21b6124c', __exports__)
  }
  
  module.hot.accept("./platform.vue?vue&type=template&id=21b6124c&scoped=true", () => {
    console.log('re-render')
    api.rerender('21b6124c', render)
  })

}


export default __exports__